import { CopyPill } from '../copy-pill/CopyPill.tsx';
import { truncateAddress } from './truncateAddress.ts';

type Props = {
  ipAddress: string;
  className?: string;
};

export function IpAddressPill({ ipAddress, className }: Props) {
  return <CopyPill value={ipAddress} displayValue={truncateAddress(ipAddress)} className={className} />;
}
